import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import { ReviewModeProvider } from "./context/ReviewModeContext";
import Login from "./components/Login";
import AdminLayout from "./layouts/AdminLayout";

import Dashboard from "./pages/Dashboard";
import Upload from "./pages/Upload";
import SearchDocuments from "./pages/SearchDocuments";
import ArchivedPolicySearch from "./pages/ArchivedPolicySearch";
import ArchivedClaimsSearch from "./pages/ArchivedClaimsSearch";
import InboxReview from "./pages/InboxReview";
import TeamQueue from "./pages/TeamQueue";
import Users from "./pages/Users";
import Roles from "./pages/Roles";
import Resources from "./pages/Resources";
import UserRoleAudit from "./pages/UserRoleAudit";
import AssignRoleResource from "./pages/AssignRoleResource";
import AssignUserRole from "./pages/AssignUserRole";
import AuditLogs from "./pages/AuditLogs";
import AccessReview from "./pages/AccessReview";
import LookupManagement from "./pages/LookupManagement";
import AdminDashboard from "./pages/AdminDashboard";
import Manage from "./pages/Manage";


import ProtectedRoute from "./components/ProtectedRoute";
import { HIDE_INBOX_REVIEW } from "./config/portalFeatureNav";

function App() {
  const isAuthenticated = useIsAuthenticated();

  return (
    <ReviewModeProvider>
      <BrowserRouter>
        <Routes>
          {!isAuthenticated ? (
            <Route path="*" element={<Login />} />
          ) : (
            <>

            <Route path="/" element={<AdminLayout />}>
              {/* USER DASHBOARD — open to all authenticated users (no-role sees contact-admin message) */}
              <Route index element={<Dashboard />} />
              <Route
                path="/upload"
                element={
                  <ProtectedRoute resource="UPLOAD_DOCUMENT" access="READ">
                    <Upload />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/search"
                element={
                  <ProtectedRoute resource="SEARCH_DOC" access="READ">
                    <SearchDocuments />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/policy-search"
                element={
                  <ProtectedRoute resource="ARCHIVAL_POLICY_SEARCH" access="READ">
                    <ArchivedPolicySearch />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/claim-search"
                element={
                  <ProtectedRoute resource="ARCHIVAL_CLAIM_SEARCH" access="READ">
                    <ArchivedClaimsSearch />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/document-hub"
                element={
                  HIDE_INBOX_REVIEW ? (
                    <Navigate to="/team-queue" replace />
                  ) : (
                    <ProtectedRoute resource="DOC_INDEX_HUB" access="READ">
                      <InboxReview />
                    </ProtectedRoute>
                  )
                }
              />
              <Route
                path="/operations-queue"
                element={
                  <ProtectedRoute resource="DOC_INDEX_HUB" access="READ">
                    <TeamQueue />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/team-queue"
                element={
                  <ProtectedRoute resource="TEAM_INBOX" access="READ">
                    <TeamQueue />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/my-queue"
                element={
                  <ProtectedRoute resource="WORK_ITEMS" access="READ">
                    <TeamQueue mode="mine" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user-role-audit"
                element={
                  <ProtectedRoute resource="ADMIN" access="READ">
                    <UserRoleAudit />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/lookups"
                element={
                  <ProtectedRoute resource="ADMIN" access="READ">
                    <LookupManagement />
                  </ProtectedRoute>
                }
              />

              {/* ADMIN DASHBOARD */}
              <Route
                path="admin-dashboard"
                element={
                  <ProtectedRoute resource="ADMIN" access="READ">
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />

              <Route
                path="manage"
                element={
                  <ProtectedRoute resource="ADMIN" access="READ">
                    <Manage />
                  </ProtectedRoute>
                }
              />
              {/* USERS */}
              <Route
                path="users"
                element={
                  <ProtectedRoute resource="ADMIN" access="READ">
                    <Users />
                  </ProtectedRoute>
                }
              />

              {/* ROLES */}
              <Route
                path="roles"
                element={
                  <ProtectedRoute resource="ADMIN" access="READ">
                    <Roles />
                  </ProtectedRoute>
                }
              />

              {/* RESOURCES */}
              <Route
                path="resources"
                element={
                  <ProtectedRoute resource="ADMIN" access="READ">
                    <Resources />
                  </ProtectedRoute>
                }
              />

              {/* USER ↔ ROLE */}
              <Route
                path="assign-user-role"
                element={
                  <ProtectedRoute resource="ADMIN" access="WRITE">
                    <AssignUserRole />
                  </ProtectedRoute>
                }
              />

              {/* ROLE ↔ RESOURCE */}
              <Route
                path="assign-role-resource"
                element={
                  <ProtectedRoute resource="ADMIN" access="WRITE">
                    <AssignRoleResource />
                  </ProtectedRoute>
                }
              />

              {/* AUDIT LOGS */}
              <Route
                path="audit-logs"
                element={
                  <ProtectedRoute resource="ADMIN" access="READ">
                    <AuditLogs />
                  </ProtectedRoute>
                }
              />

              {/* ACCESS REVIEW  */}
              <Route
                path="access-review"
                element={
                  <ProtectedRoute resource="ADMIN" access="READ">
                    <AccessReview />
                  </ProtectedRoute>
                }
              />
            </Route>
            </>
          )}
        </Routes>
      </BrowserRouter>
    </ReviewModeProvider>
  );
}

export default App;
